export const lclWeightUnit = {
  t: "MT",
  kg: "KG",
};
